import { useState } from "react";
import { showUrlCopiedNotification } from "@/utils/notification-helper";

const copyClipBoardCommand = (text: string): void => {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.left = "-9999px";

  document.body.appendChild(textarea);
  textarea.select();

  try {
    document.execCommand("copy");
  } catch (err) {
    document.body.removeChild(textarea);
  }

  document.body.removeChild(textarea);
};

export const useClipboard = () => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async (
    text: string,
    showNotification: boolean = true,
  ) => {
    setIsCopied(true);
    if (showNotification) {
      showUrlCopiedNotification();
    }

    try {
      await navigator.clipboard.writeText(text);
    } catch (_) {
      copyClipBoardCommand(text);
    }
  };

  return {
    isCopied,
    copyToClipboard,
  };
};
